/* eslint-disable no-unused-vars */

import { CaptionText, H4, P1, P2, P3 } from '../../../styles/FontStyles';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { color, colors } from '../../../styles/GlobalStyles';
import { BoxBig, HubImage, Td, Tr } from '../Portfolio.styled';
import moment from 'moment';
import {
  LP,
  formatUSD,
  formatUSDNoDecimals
} from '../../../helpers/helperFunctions';
import { Responsive } from '../../../styles/stylesStyled';
import { useTranslation } from 'react-i18next';
import Spinner from '../../../components/common/Spinner';
import { useDispatch } from 'react-redux';
import { activateMyHubsU1Academy } from '../Portfolio.actions';

export const U1AcademyItem = ({
  item,
  isAllActive
}: {
  item: any;
  isAllActive?: boolean;
}) => {
  const { t } = useTranslation('my_hubs');

  const dispatch = useDispatch();

  return (
    <BoxBig relative>
      <HubImage image={item?.imageUrl}>
        <H4 color={color.colors.neutral0}>{item.product?.name}</H4>
      </HubImage>
      <Flexed column between>
        <Flexed>
          <div
            style={{
              position: 'absolute',
              left: '50%',
              right: '50%',
              transform: 'translate(-50%, -50%)'
            }}>
            <Spinner />
          </div>
          <Tr style={{ cursor: 'pointer' }}>
            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                ORDER ID
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                {item?.id}
              </P1>
            </Td>

            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('date_of_purchase')}
              </CaptionText>
              <P1 bold>{moment(item?.datePaid).format('DD MMMM YYYY')}</P1>
            </Td>
          </Tr>
        </Flexed>
        <Flexed between rowSM>
          <P2 mr='5' bold color={colors.primary900} mbSM='10'>
            Academy Access: {item?.name}
          </P2>
          {!isAllActive ? (
            <Button
              w='150px'
              h='40px'
              onClick={() => dispatch(activateMyHubsU1Academy())}>
              Activate
            </Button>
          ) : item?.isActive ? (
            <></>
          ) : (
            <Button
              w='150px'
              h='40px'
              onClick={() => dispatch(activateMyHubsU1Academy())}>
              Upgrade
            </Button>
          )}
        </Flexed>
      </Flexed>
    </BoxBig>
  );
};
